import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

// Country - Get All
export const AllState = createAsyncThunk(
  "/state",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllState}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });
      return await Select2Data(res.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllDistrict = createAsyncThunk(
  "/district",
  async ({ state_id, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllDistrict}?state_id=${state_id}&name=${name}`,
        {
          headers: {
            platform: process.env.REACT_APP_PLATFORM,
            appversion: process.env.REACT_APP_APP_VERSION,
          },
        },
      );

      return await Select2Data(res.data, "district_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTaluka = createAsyncThunk(
  "/taluqa",
  async ({ district_id, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllTaluka}?district_id=${district_id}&name=${name}`,
        {
          headers: {
            platform: process.env.REACT_APP_PLATFORM,
            appversion: process.env.REACT_APP_APP_VERSION,
          },
        },
      );

      return await Select2Data(res.data, "taluqa_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCartegory = createAsyncThunk(
  "/servicecategory",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCartegory}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });

      return await Select2Data(res.data, "category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllProfession = createAsyncThunk(
  "/get-profession",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllProfession}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });

      return await Select2Data(res.data, "profession_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPrivacyPolicy = createAsyncThunk(
  "common/masters/privacy-policy",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPrivacyPolicy);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTermcondition = createAsyncThunk(
  "common/masters/terms-condition",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTermcondition);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAppSetup = createAsyncThunk(
  "common/masters/appsetup",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllAppSetup);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCategories = createAsyncThunk(
  "common/masters/servicecategoryss",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCategories);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllProfessions = createAsyncThunk(
  "common/masters/get-professionsss",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllProfessions);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllPurchaseDate = createAsyncThunk(
  "/get-purchase-date",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPurchaseDate}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });
      return await Select2Data(res.data, "purchase_date");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Home Strip text
export const AllHomeText = createAsyncThunk(
  "common/masters/homestriptext",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllHomeText);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Home Banner Text
export const AllBannerText = createAsyncThunk(
  "common/masters/homebannertxt",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllBannerText);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Hiring partners
export const AllHiringPartners = createAsyncThunk(
  "common/masters/hiringpartner",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllHiringPartners);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Success Story
export const AllSuccessStory = createAsyncThunk(
  "common/masters/successStory",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllSuccessStory);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// SpotLight Story
export const AllSpotLights = createAsyncThunk(
  "common/masters/spotlight",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllSpotLights);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Learn Video
export const AllLearnVideos = createAsyncThunk(
  "common/masters/learnvideos",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllLearnVideos);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Placement Team
export const AllPlacementTeam = createAsyncThunk(
  "common/masters/placementTeam",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPlacementTeam);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Alumni Placed At
export const AllAlumniPlace = createAsyncThunk(
  "common/masters/alumniplace",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllAlumniPlace);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Alumni Placed At
export const AllBuildCareer = createAsyncThunk(
  "common/masters/buildcareer",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllBuildCareer);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Blog
export const AllBlogs = createAsyncThunk(
  "common/masters/blogs",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllBlogs);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// // Blog Detail
// export const BlogDetail = createAsyncThunk(
//   "common/masters/blogdetail",
//   async (blog_id, { rejectWithValue }) => {
//     try {
//       const res = await GET(`${APIS.Commons.BlogDetail}?blog_id=${blog_id}`);
//       return res;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );

// Blog Detail
export const BlogDetail = createAsyncThunk(
  "common/masters/blogdetail",
  async (blog_id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.BlogDetail}?blog_id=${blog_id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Interview Guide
export const AllInterviewGuide = createAsyncThunk(
  "common/masters/interviewguide",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllInterviewGuide);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Branches
export const AllBranches = createAsyncThunk(
  "common/masters/branches",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllBranches);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Qualification
export const AllQualification = createAsyncThunk(
  "common/masters/qualifications",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllQualification);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Social Media Links
export const AllSocialLinks = createAsyncThunk(
  "common/masters/socialLinks",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllSocialLinks);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Mentors
export const AllMentors = createAsyncThunk(
  "common/masters/mentors",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllMentors);

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Programs list
export const AllProgramList = createAsyncThunk(
  "common/masters/programlist",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllProgramList);

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Program Detail by ID
export const ProgramDetail = createAsyncThunk(
  "common/masters/programs",
  async (program_id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.ProgramDetail}?program_id=${program_id}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Program Detail by Program Category ID
export const ProgramByID = createAsyncThunk(
  "common/masters/programcategoryid",
  async (program_category_id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.ProgramByID}?program_category_id=${program_category_id}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Home Image
export const AllHomeImage = createAsyncThunk(
  "common/masters/homeimage",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllHomeImage);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Program Category
export const AllProgramCategory = createAsyncThunk(
  "common/masters/programcategory",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllProgramCategory);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Comments
export const AllComments = createAsyncThunk(
  "common/masters/getcomments",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllComments);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Get All quiz
export const AllQuiz = createAsyncThunk(
  "common/masters/quiz",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllQuiz);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Industry Experts
export const AllIndustryExperts = createAsyncThunk(
  "common/masters/industry_expert",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllIndustryExperts);

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


export const Slice = createSlice({
  name: "common",
  initialState: {
    all_state: [],
    all_district: [],
    all_category: [],
    all_profession: [],
    all_privacy_policy: [],
    all_terms_condition: [],
    all_app_setup: [],
    all_categories: [],
    all_professions: [],
    all_purchase_date: [],
    all_taluka: [],
    all_home_text: [],
    all_banner_text: [],
    all_hiring_partners: [],
    all_success_story: [],
    all_spotlight: [],
    all_learn_video: [],
    all_placement_Team: [],
    all_alumni_place: [],
    all_build_career: [],
    all_blogs: [],
    blog_detail: [],
    all_interview_guide: [],
    all_branches: [],
    all_qualification: [],
    all_social_links: [],
    all_mentors: [],
    all_program_list: [],
    program_detail: [],
    all_home_image: [],
    all_program_category: [],
    program_by_id: [],
    all_comments: [],
    all_quiz: [],
    all_industry_experts: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllDistrict.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDistrict.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_district = action.payload || [];
      })
      .addCase(AllDistrict.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTaluka.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTaluka.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_taluka = action.payload || [];
      })
      .addCase(AllTaluka.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCartegory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCartegory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCartegory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProfession.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProfession.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_profession = action.payload || [];
      })
      .addCase(AllProfession.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPrivacyPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPrivacyPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_privacy_policy = action.payload;
      })
      .addCase(AllPrivacyPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllTermcondition.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTermcondition.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_terms_condition = action.payload;
      })
      .addCase(AllTermcondition.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllAppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_app_setup = action.payload;
      })
      .addCase(AllAppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCategories.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategories.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_categories = action.payload;
      })
      .addCase(AllCategories.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProfessions.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProfessions.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_professions = action.payload;
      })
      .addCase(AllProfessions.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllPurchaseDate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPurchaseDate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_purchase_date = action.payload || [];
      })
      .addCase(AllPurchaseDate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllHomeText.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHomeText.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_home_text = action.payload || [];
      })
      .addCase(AllHomeText.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBannerText.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBannerText.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_banner_text = action.payload || [];
      })
      .addCase(AllBannerText.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllHiringPartners.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHiringPartners.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_hiring_partners = action.payload || [];
      })
      .addCase(AllHiringPartners.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSuccessStory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSuccessStory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_success_story = action.payload || [];
      })
      .addCase(AllSuccessStory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSpotLights.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSpotLights.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_spotlight = action.payload || [];
      })
      .addCase(AllSpotLights.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllLearnVideos.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllLearnVideos.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_learn_video = action.payload || [];
      })
      .addCase(AllLearnVideos.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPlacementTeam.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPlacementTeam.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_placement_Team = action.payload || [];
      })
      .addCase(AllPlacementTeam.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAlumniPlace.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAlumniPlace.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_alumni_place = action.payload || [];
      })
      .addCase(AllAlumniPlace.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBuildCareer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBuildCareer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_build_career = action.payload || [];
      })
      .addCase(AllBuildCareer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBlogs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBlogs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_blogs = action.payload || [];
      })
      .addCase(AllBlogs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(BlogDetail.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(BlogDetail.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.blog_detail = action.payload?.data?.[0] || null;
      })
      .addCase(BlogDetail.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllInterviewGuide.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllInterviewGuide.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_interview_guide = action.payload || [];
      })
      .addCase(AllInterviewGuide.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBranches.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBranches.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_branches = action.payload?.data || [];
      })
      .addCase(AllBranches.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllQualification.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllQualification.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_qualification = action.payload?.data || [];
      })
      .addCase(AllQualification.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSocialLinks.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSocialLinks.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_social_links = action.payload?.data || [];
      })
      .addCase(AllSocialLinks.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllMentors.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllMentors.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_mentors = action.payload?.data || [];
      })
      .addCase(AllMentors.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProgramList.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProgramList.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_program_list = action.payload?.data || [];
        // state.all_program_list = action.payload?.data?.[0] || null;
      })
      .addCase(AllProgramList.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(ProgramDetail.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(ProgramDetail.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.program_detail = action.payload?.data || [];
      })
      .addCase(ProgramDetail.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllHomeImage.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHomeImage.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_home_image = action.payload || [];
      })
      .addCase(AllHomeImage.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProgramCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProgramCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_program_category = action.payload || [];
      })
      .addCase(AllProgramCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(ProgramByID.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(ProgramByID.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.program_by_id = action.payload?.data || [];
      })
      .addCase(ProgramByID.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllComments.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllComments.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_comments = action.payload || [];
      })
      .addCase(AllComments.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllQuiz.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllQuiz.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_quiz = action.payload || [];
      })
      .addCase(AllQuiz.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllIndustryExperts.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllIndustryExperts.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_industry_experts = action.payload?.data || [];
      })
      .addCase(AllIndustryExperts.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
